module.exports = __webpack_public_path__ + "static/media/Location.18c14b80.svg";